/* ui/editor/EditorPage.svelte generated by Svelte v3.23.2 */
import {
	SvelteComponent,
	append,
	attr,
	binding_callbacks,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal
} from "svelte/internal";

import { CodeJar } from "codejar";
import { withLineNumbers } from "codejar/linenumbers";
import { onMount } from "svelte";
import hljs from "highlight.js";
import { game } from "../store";
import { codeStore } from "../../stores/player_store";

function add_css() {
	var style = element("style");
	style.id = "svelte-zc3899-style";
	style.textContent = ".editor.svelte-zc3899{border-radius:3px;font-family:'Source Code Pro', monospace;font-size:14px;font-weight:400;letter-spacing:normal;line-height:20px;min-height:700px}pre.svelte-zc3899{margin:0px;margin-left:5px;width:80%;height:100%}div.svelte-zc3899{display:grid;place-items:center}";
	append(document.head, style);
}

function create_fragment(ctx) {
	let div;
	let pre;
	let code;

	return {
		c() {
			div = element("div");
			pre = element("pre");
			code = element("code");
			attr(code, "class", "language-js editor svelte-zc3899");
			attr(pre, "class", "svelte-zc3899");
			attr(div, "class", "svelte-zc3899");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, pre);
			append(pre, code);
			/*code_binding*/ ctx[1](code);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
			/*code_binding*/ ctx[1](null);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let codeEditor;

	const editorOptions = {
		tab: (" ").repeat(2), // two space indentation
		
	};

	const highlight = editor => {
		// highlight.js does not trims old tags,
		// let's do it by this hack.
		editor.textContent = editor.textContent;

		hljs.highlightBlock(editor);
	};

	onMount(() => {
		// create editor and save off any updates
		const jar = CodeJar(codeEditor, withLineNumbers(highlight), editorOptions);

		jar.onUpdate(code => {
			codeStore.update(c => code);
			game.reset();
		});

		// see if they have previously saved code and load it
		const storedCode = window.localStorage.getItem("ai_code");

		if (storedCode) {
			jar.updateCode(storedCode);
		}
	});

	function code_binding($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			codeEditor = $$value;
			$$invalidate(0, codeEditor);
		});
	}

	return [codeEditor, code_binding];
}

class EditorPage extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-zc3899-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default EditorPage;